import { Link } from "react-router-dom";

const LinkContainer = ({ to, style, className, children }) => {
  return (
    <Link to={to} style={style} className={className}>
      {children}
    </Link>
  );
};

export default LinkContainer;
